"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WasIstQiGong() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="159839" id="datenschutzerklärung" className="bg-background text-foreground relative overflow-hidden py-24 md:py-40">
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        <div ref={ref} className={`flex flex-col md:flex-row items-start gap-12 md:gap-24 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {/* Vertical Title for Desktop */}
          <div className="hidden md:flex w-24 lg:w-32 shrink-0 justify-center items-start pt-4">
            <h2 className="text-7xl lg:text-9xl font-sans font-bold text-secondary tracking-tighter whitespace-nowrap select-none" style={{
            writingMode: "vertical-rl",
            transform: "rotate(180deg)"
          }}>
              Datenschutz
            </h2>
          </div>

          {/* Title for Mobile */}
          <div className="md:hidden w-full">
            <h2 className="text-5xl sm:text-6xl font-sans font-bold text-secondary tracking-tighter leading-none">
              Daten
              <br />
              schutz
            </h2>
            <div className="h-1 w-24 bg-primary mt-6"></div>
          </div>

          {/* Content Area with Card Effect */}
          <div className="flex-1 max-w-4xl md:pt-12 lg:pt-24 bg-card border border-border shadow-lg p-8 md:p-16 rounded-sm">
            <div className="font-mono text-sm text-muted-foreground mb-6 tracking-wider uppercase">
              Sektion 01.0 // Vertraulichkeit
            </div>
            <p className="text-xl md:text-2xl lg:text-3xl font-sans font-normal leading-relaxed text-foreground">
              Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Erklärung.
            </p>
            <p className="mt-8 md:mt-12 text-base md:text-lg font-sans font-normal leading-relaxed text-muted-foreground">
              In dieser Datenschutzerklärung informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website. Wir nutzen modernste Sicherheitsstandards und verschlüsselte Übertragungswege, um Ihre Informationen vor unbefugtem Zugriff zu schützen und eine transparente Verarbeitung zu gewährleisten.
            </p>
            <div className="mt-12 pt-8 border-t border-border">
              <a href="#" className="text-primary hover:text-secondary font-sans font-medium transition-colors duration-200">
                Vollständige Richtlinien einsehen →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}